import { getAssetAbsoluteUrl } from '../utils/assetUrl.utils';

export const UNAVAILABLE_CAR_IMAGE = getAssetAbsoluteUrl(`/images/unavailable-car.png`);
